var angular = require('angular');
var _module = require('./index');

_module.directive('peopleLoveUs', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/people-love-us.tmpl.html',
        scope: {
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;

            }
        ]
    };
}]);
